import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ca-modal-success',
    templateUrl: './modal-success.component.html',
    styleUrls: ['./modal-success.component.scss'],
})
export class ModalSuccessComponent {
    @Input() title = this.translateService.instant('MODAL_SUCCESS.SUCCESS');
    @Input() message = this.translateService.instant('MODAL_SUCCESS.SUCCESS_MESSAGE');
    @Input() buttonText = this.translateService.instant('MODAL_SUCCESS.DONE');
    @Input() buttonAction: Function;

    inputText: string = '';

    constructor(
        private activeModal: NgbActiveModal,
        private translateService: TranslateService,
    ) {}

    close(): void {
        if (this.buttonAction != null) {
            this.buttonAction.call(this);
        }
        this.activeModal.close();
    }
}
